module.exports = __webpack_public_path__ + "img/cos.c9255058.png";